import React from 'react';
import { TextButton } from './TextButton';
import './FormatErrorMessage.scss';
export const FormatErrorMessage = React.memo(({ onCancelClick, children }) => {
    return (React.createElement("div", { className: "CSVImporter_FormatErrorMessage" },
        React.createElement("span", null, children),
        React.createElement(TextButton, { onClick: onCancelClick }, "Go Back")));
});
